export const SHORT_TERM_CARE = 'shortTermCare'
export const LONG_TERM_CARE = 'longTermCare'
export const DAY_AND_NIGHT_CARE = 'dayAndNightCare'
